import React from 'react';

const BilingualField = ({
  label, labelEn, labelAr,
  valueEn, valueAr, onChangeEn, onChangeAr,
  type = 'input', multiline = false, rows = 3,
  required = false, placeholder = ''
}) => {
  const inputClass = "w-full bg-[#1A1A1A] border border-[rgba(212,175,55,0.2)] rounded-sm px-3 py-2 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition-colors";
  const rtlInputClass = `${inputClass} text-right`;
  const isTextarea = type === 'textarea' || multiline;

  return (
    <div className="space-y-2">
      {label && <label className="block text-xs uppercase tracking-wider text-[#D4AF37] font-semibold">{label}{required && ' *'}</label>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1">
          <span className="text-[10px] uppercase tracking-wider text-white/40">{labelEn || 'English'}</span>
          {isTextarea ? (
            <textarea
              value={valueEn}
              onChange={e => onChangeEn(e.target.value)}
              placeholder={placeholder}
              rows={rows}
              className={`${inputClass} resize-none`}
            />
          ) : (
            <input
              type="text"
              value={valueEn}
              onChange={e => onChangeEn(e.target.value)}
              placeholder={placeholder}
              className={inputClass}
            />
          )}
        </div>
        <div className="space-y-1">
          <span className="text-[10px] uppercase tracking-wider text-white/40">{labelAr || 'عربي'}</span>
          {isTextarea ? (
            <textarea
              value={valueAr}
              onChange={e => onChangeAr(e.target.value)}
              placeholder={placeholder}
              dir="rtl"
              rows={rows}
              className={`${rtlInputClass} resize-none`}
            />
          ) : (
            <input
              type="text"
              value={valueAr}
              onChange={e => onChangeAr(e.target.value)}
              placeholder={placeholder}
              dir="rtl"
              className={rtlInputClass}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BilingualField;
